// Module-level flag so the API client, which lives outside React, can refuse
// writes while a role preview is active. AuthContext keeps it in step.

let active = false;
let message = '';
const listeners = new Set();
const activeListeners = new Set();

const SAFE_METHODS = ['get', 'head', 'options'];

export function setPreviewGuard(isActive, text = '') {
    const next = Boolean(isActive);
    const changed = next !== active;
    active = next;
    message = active ? text : '';
    if (changed) activeListeners.forEach((listener) => listener());
}

export function subscribePreviewActive(listener) {
    activeListeners.add(listener);
    return () => activeListeners.delete(listener);
}

export function isPreviewGuardActive() {
    return active;
}

export function previewBlocksMethod(method) {
    return (
        active && !SAFE_METHODS.includes(String(method || 'get').toLowerCase())
    );
}

export function previewBlockedError() {
    const error = new Error(message);
    error.previewBlocked = true;
    listeners.forEach((listener) => listener(message));
    return error;
}

export function subscribePreviewBlocked(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
